import React, { useState, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { VEHICLE_TYPE } from '@/utils/constants'
import {
  createOpportunity,
  sortFilterItemsAscendingByKey,
  getFilterItems,
  sortOpportunities,
} from '@/modern/utils/filter'

import OpportunitiesFilterItem from './components/OpportunitiesFilterItem'

import * as S from './style'
import { setEventToLazyDispatch } from '@/utils/utils'

const OpportunitiesFilters = ({
  addUrl,
  showSearchPlaceholder,
  filterChange,
  vehicleType,
  categoryCookieActive
}) => {
  const filterKey = 'Opportunities'
  const { result } = useSelector(({ searchResultState }) => searchResultState)

  const createFilterState = filterOptions =>
    filterOptions.reduce((filterState, opportunity) => {
      return {
        ...filterState,
        [opportunity.id]: {
          ...opportunity,
        },
      }
    }, {})

  const opportunities = useMemo(
    () =>
      getFilterItems(result, filterKey)
        .map(createOpportunity)
        .sort(sortOpportunities(sortFilterItemsAscendingByKey('name'))),
    [result]
  )

  const [filters, setFilters] = useState(() => createFilterState(opportunities))
  const dataTestid = `filter_${filterKey}`

  const handleSelect = opportunity => {
    const newFilters = {
      ...filters,
      [opportunity.id]: {
        ...filters[opportunity.id],
        selected: !opportunity.selected,
      },
    }
    setFilters(newFilters)

    categoryCookieActive && setEventToLazyDispatch("filtroRealizado")
  }

  useEffect(() => {
    const newFilters = createFilterState(opportunities)
    setFilters(newFilters)
  }, [opportunities])

  if (opportunities.length < 1) return null

  return (
    <S.Container data-testid={dataTestid}>
      <S.Title>O que é interessante pra você?</S.Title>

      {Object.values(filters).map(opportunity => (
        <OpportunitiesFilterItem
          dataQA="filter_opportunity"
          key={opportunity.name}
          opportunity={opportunity}
          addUrl={addUrl}
          beginSearchLoad={showSearchPlaceholder}
          filterChange={filterChange}
          vehicleType={vehicleType}
          handleSelect={handleSelect}
          testIdPrefix={dataTestid}
        />
      ))}
    </S.Container>
  )
}

OpportunitiesFilters.propTypes = {
  addUrl: PropTypes.func.isRequired,
  showSearchPlaceholder: PropTypes.func.isRequired,
  filterChange: PropTypes.func.isRequired,
  vehicleType: PropTypes.oneOf([VEHICLE_TYPE.car, VEHICLE_TYPE.bike])
    .isRequired,
}

export default OpportunitiesFilters
